import { Checkbox } from "@business-finland/wif-ui-lib";
import dynamic from "next/dynamic";

import CompanyFieldset from "./Fieldset";
import {
  useCompanyFormDispatch,
  companyFormActions,
  useCompanyFormState,
} from "../store";

const HtmlParser = dynamic(() => import("../../../../components/HtmlParser"));

export default function CompanyTerms({
  terms, terms2
}: {
  terms: string;
  terms2?: string;
}): JSX.Element {
  const state = useCompanyFormState();
  const dispatch = useCompanyFormDispatch();

  const handleChange = (checked: boolean) => {
    dispatch(companyFormActions.setValue({ companyTerms: checked }));
  };

  const handleChange2 = (checked: boolean) => {
    dispatch(companyFormActions.setValue({ companyTerms2: checked }));
  };

  return (
    <CompanyFieldset id="terms" heading="">
      <Checkbox
        label={<HtmlParser html={terms} />}
        name="companyTerms"
        checked={state.companyTerms ?? false}
        onChange={handleChange}
        onDarkBackground
        required
        error={!state.companyTerms}
      />
      {!!terms2 && (
        <Checkbox
          label={<HtmlParser html={terms2} />}
          name="companyTerms2"
          checked={state.companyTerms2 ?? false}
          onChange={handleChange2}
          onDarkBackground
          required
          error={!state.companyTerms2}
        />
      )}
    </CompanyFieldset>
  );
}
